import * as React from "react";

export function PdfViewer({blob, fileName}) {
    return <iframe
        id={"attachmentPreviewIFrame"}
        key={0}
        src={URL.createObjectURL(blob)}
        title={fileName}
        style={{
            width: '100%',
            height: '100%',
            border: 'none',
            display: 'block'
        }}
    />
}